import React, { Component } from "react";
import { Helmet } from "react-helmet";

class PageHelmet extends Component {
  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>{this.props.pageTitle}</title>
          <meta
            name="description"
            content="Agence de développement web et mobile. Nous réalisons des sites web et des applications mobiles sur mesure, pour les particuliers, startups, PME et grandes entreprises."
          />
        </Helmet>
      </React.Fragment>
    );
  }
}

export default PageHelmet;
